export default "__VITE_ASSET__54e4ca22__"